import { React,useState} from "react";
const FootBallScoreBoard = ({eventDetails,scoreboardData}) => { 

    let current_set = 0;
    let homeName = "";
    let awayName = "";

    let homeScore = "";
    let awayScore = "";
    let soccerTime = "";

 
    let regualrTime = "";
    let regualrTime2 = 0;
    
    let secondHalfbar = 0; 
    let firstHalfbar = 0; 
    

    if(scoreboardData!==null && scoreboardData!==undefined) {
         
        let data = scoreboardData;
        let scoreData = data[0].score;
        let currentSet = data[0].currentSet;
        if (scoreData!==null && scoreData!==undefined) {

             current_set = (currentSet);
            homeName = (scoreData.home.name);
            awayName = (scoreData.away.name);

            homeScore = (scoreData.home.score);
            awayScore = (scoreData.away.score);
            soccerTime = (data[0].elapsedRegularTime + "'");

            regualrTime = Number(data[0].elapsedRegularTime);
            let newFirstHalfbar = 0;
            if (regualrTime <= 45) {
                newFirstHalfbar = regualrTime * 2.3;
            } else {
                newFirstHalfbar = 45 * 2.3;
            }
            firstHalfbar = newFirstHalfbar;
            

            if (regualrTime > 45) {
                regualrTime2 = regualrTime - 45;
                secondHalfbar = regualrTime2 * 2.3;
            } 
        } 
    }
    
    return( 
        <div>
            <style>
            {`.scores {
                    background-color: #2b2f35;
                    border: 1px solid #2b2f35;
                    padding: 0.25rem;
                }
                .scores .runnername {
                    margin-top: 7px;
                    line-height: 0.2;
                    color: white;
                    font-size: 18px;
                }
                .scores .runner-score {
                    color: white;
                    font-size: 18px;
                    margin-top: 2px;
                    padding: 0px;
                }
                .colwidthset {
                    width: 1vw;
                }
                .scores .active {
                    color: #009069;
                }
                .scores .col-divider {
                    border-left: 1px solid white;
                }
                .tablefotercs {
                    font-size: 12px;
                    color: white;
                }
                @media screen and (max-width: 767px) {
                    .scores .runnername {
                        margin-top: 7px;
                        line-height: 0.2;
                        color: white;
                        font-size: 12px;
                    }
                    .sethourshow {
                        line-height: 0.3;
                        font-size: 15px;
                    }
                    .tableresp {
                        display: inline-table;
                    }
                    .colwidthset {
                        width: 50px;
                    }
                    .tablefotercs {
                        font-size: 11px;
                        color: white;
                    }
                }
            
                /* soccer */
                .timelineNS {
                    background: #303030;
                    height: 32px;
                    position: relative;
                }
            
                .timelineNS .half {
                    height: 6px;
                    float: left;
                    box-sizing: border-box;
                    position: relative;
                    margin-top: 13px;
                    margin-bottom: 13px;
                    width: 50%;
                }
            
                .timelineNS .firstHalf {
                    margin-left: -4px;
                }
            
                .timelineNS .empty-bar {
                    background: linear-gradient(0deg, #9c9c9c, #fff);
                    height: 5px;
                    position: absolute;
                    left: 6px;
                    right: 6px;
                }
            
                .timelineNS .empty-bar .bar {
                    background: linear-gradient(0deg, #087d0e, #0c0);
                    height: 5px;
                    max-width: 100%;
                }
            
                .timelineNS .tooltipNS {
                    position: absolute;
                    z-index: 1;
                }
            
                .timelineNS .top {
                    top: -18px;
                }
            
                .timelineNS .secondHalf {
                    margin-left: 4px;
                }
            
                .fa-basketball-ball {
                    color: #fff;
                }
            
                .timelineNS .tooltiptextNS {
                    display: none;
                    width: 100px;
                    background-color: #f8f8ff;
                    color: #000;
                    text-align: center;
                    border-radius: 6px;
                    height: auto;
                    border: 1px solid #000;
                }
            
                .timelineNS .toptt {
                    margin-top: -60px;
                }
            
                .timelineNS .tooltiptextNS p {
                    margin-bottom: 0;
                    font-size: small;
                }
            
                .timeshow {
                    color: white;
                    font-size: 18px;
                }
            `}
        </style>
            <div className="scores">
                <div className="row" style={{margin: "0px"}}>
                    <div className="col-4 socindivs">
                        <div className="runnername" id="homeName">{homeName}</div>
                        <div className="runner-score mt-2"><b id="homeScore">{homeScore}</b></div>
                    </div>
                    <div className="col-4 socindivs" style={{textAlign:"center"}}>
                        <div className="runnername"><b>Time</b></div>
                        <div className="timeshow mt-2" ><span id="soccerTime">{soccerTime}</span></div>
                    </div>
                    <div className="col-4 socindivs" style={{textAlign:"right"}}>
                        <div className="runnername" id="awayName">{awayName}</div>
                        <div className="runner-score mt-2"><b id="awayScore">{awayScore}</b></div>
                    </div>
                </div>
                <div className="timelineNS" id="soccerScoreCardHtml">
                    <div className="half firstHalf">
                        <div className="empty-bar">
                            <div className="bar" style={{width:firstHalfbar + "%"}} id="firstHalfbar">
                                sssss
                            </div>
                        </div>
                    </div>
                    <div className="half secondHalf">
                        <div className="empty-bar">
                            <div className="bar" style={{width: secondHalfbar + "%"}} id="secondHalfbar">
                                tttt
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     )
}

export default FootBallScoreBoard;

{/*
 let data = scoreBoard;
let scoreData = data[0].score;
let currentSet = data[0].currentSet;
//console.log(scoreData);
if (scoreData) {
    $('#current_set').html(currentSet);
    $('#homeName').html(scoreData.home.name);
    $('#awayName').html(scoreData.away.name);

let html2 = '<tr>';
html2 += '<td class="runner-score colwidthset ">' + scoreData.home.score + '</td>';
html2 += '</tr>';
html2 += '<tr>';
html2 += '<td class="runner-score colwidthset ">' + scoreData.away.score + '</td>';
html2 += '</tr>';
html2 += '<tr class="col-12 tablefotercs">';
html2 += '<td class="colwidthset">Goal</td>';
html2 += '</tr>';

    
$('#soccerScoreCard').html(html2);

///
$('#homeScore').html(scoreData.home.score);
$('#awayScore').html(scoreData.away.score);
$('#soccerTime').html(data[0].elapsedRegularTime + "'");

///
let regualrTime = Number(data[0].elapsedRegularTime);
let regualrTime2 = 0;
let firstHalfbar = 0;
let secondHalfbar = 0;
if (regualrTime <= 45) {
    firstHalfbar = regualrTime * 2.3;
} else {
    firstHalfbar = 45 * 2.3;
}
if (regualrTime > 45) {
    regualrTime2 = regualrTime - 45;
    secondHalfbar = regualrTime2 * 2.3;
}
$('#firstHalfbar').css('width', firstHalfbar + '%');
$('#secondHalfbar').css('width', secondHalfbar + '%')
*/}